/**
 * The orders GET /api/campaigns can list campaigns in, always newest first: by id, which is the
 * order of creation and the API's default, or by the last change (GAP-1503).
 */
export const CAMPAIGNS_SORT = Object.freeze({
    ID: 'ID',
    MODIFIED: 'MODIFIED',
});

/**
 * Maps the Campaigns search criteria to the query params of GET /api/campaigns.
 *
 * Each empty criterion is left out, because a missing param means "no filter": no name, no
 * type, or an unticked Active box (which returns active and inactive campaigns alike, so
 * active is only ever sent as true). The criteria may be omitted or null, in which case nothing
 * is filtered. `sort` is sent only when a search asks for an order (CAMPAIGNS_SORT), as the one
 * after a campaign is updated does; the search form never does.
 */
export default function toCampaignsSearchParams(criteria) {
    const { name, types, active, sort } = criteria || {};
    const trimmedName = (name || '').trim();

    return {
        ...(trimmedName && { name: trimmedName }),
        ...(types && types.length && { type: types.join(',') }),
        ...(active && { active: true }),
        ...(sort && { sort }),
    };
}
